import { ArrowLeft, GitBranch, LoaderCircle, Mail, ShieldCheck } from 'lucide-react'
import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { forgotPassword } from '../api.js'
import { useLanguage } from '../contexts/LanguageContext.jsx'
import { NOINDEX_ROBOTS, setPageMetadata } from '../page-metadata.js'

function ForgotPasswordPage() {
  const { t } = useLanguage()
  const [email, setEmail] = useState('')
  const [submitting, setSubmitting] = useState(false)
  const [message, setMessage] = useState('')
  const [error, setError] = useState('')

  useEffect(() => setPageMetadata({
    title: '找回密码 - 青途 AI',
    description: '青途 AI 账号密码找回。',
    robots: NOINDEX_ROBOTS,
  }), [])

  const submit = async (event) => {
    event.preventDefault()
    setSubmitting(true)
    setMessage('')
    setError('')
    try {
      const data = await forgotPassword(email)
      setMessage(data.message || '如果该邮箱已注册，我们会发送重置邮件。')
    } catch {
      setError('邮件发送失败，请稍后再试或联系管理员。')
    } finally {
      setSubmitting(false)
    }
  }

  return (
    <main className="auth-action-screen">
      <section className="auth-action-panel">
        <Link to="/" className="auth-brand auth-action-brand">
          <span className="brand-icon"><GitBranch size={22} /></span>
          <span>
            <strong>{t('nav.brand')}</strong>
            <small>{t('nav.brandSub')}</small>
          </span>
        </Link>
        <span className="auth-action-icon"><ShieldCheck size={28} /></span>
        <span className="eyebrow">ACCOUNT SECURITY</span>
        <h1>找回密码</h1>
        <p>输入注册邮箱，我们会发送密码重置链接。</p>
        <p className="auth-action-note">GitHub 登录账号没有本地密码，请前往 GitHub 修改密码。</p>

        <form className="auth-form" onSubmit={submit}>
          <label htmlFor="forgot-email">邮箱</label>
          <div className="input-wrap">
            <Mail size={18} />
            <input
              id="forgot-email"
              type="email"
              value={email}
              placeholder="输入注册邮箱"
              onChange={(event) => setEmail(event.target.value)}
              autoComplete="email"
              required
              maxLength={190}
            />
          </div>
          {message && <p className="form-success" role="status">{message}</p>}
          {error && <p className="form-error" role="alert">{error}</p>}
          <button className="primary-button auth-action-button" type="submit" disabled={submitting}>
            {submitting && <LoaderCircle className="spin" size={17} />}
            {submitting ? '处理中...' : '发送重置邮件'}
          </button>
        </form>

        <Link className="auth-action-home" to="/login">
          <ArrowLeft size={15} /> 返回登录
        </Link>
      </section>
    </main>
  )
}

export default ForgotPasswordPage
